const NotFound = (props: { onRouteNotFound: any }) => {
  return (
    <>
      {(props.onRouteNotFound && props.onRouteNotFound()) || (
        <p>404 Not Found</p>
      )}
    </>
  );
};

export default NotFound;
